<svelte:head>

    <title>List • keyosh</title>

</svelte:head>

<script>

    import SessionManager from "../components/utils/session.svelte";
    import Table from "../components/table.svelte";

</script>

<SessionManager />

<section>

    <Table/>

</section>


<style>

    section {
        height: inherit;
    }

</style>
